const prefix = 'data-table-filter-bar';

export const i18n = {
    clearAll: {
        id: `${prefix}.clearAll`,
        defaultMessage: 'Clear all',
    },
    selectAll: {
        id: `${prefix}.selectAll`,
        defaultMessage: 'Select all',
    },
} as const;
